document.addEventListener('DOMContentLoaded', function () {
  const popup = document.querySelector('.age-popup-inner');

  if (!popup) return;

  const closeTrigger = popup.querySelector('.age-popup-btn a');
  const storageKey = 'agePopupClosed';
  let popupClosed = false;

  try {
    popupClosed = window.localStorage.getItem(storageKey) === 'true';
  } catch (error) {
    popupClosed = false;
  }

  if (!popupClosed) {
    popup.classList.add('popup-open');
    document.body.classList.add('popup-open');
  }

  if (!closeTrigger) return;

  closeTrigger.addEventListener('click', function (event) {
    event.preventDefault();
    popup.classList.remove('popup-open');
    document.body.classList.remove('popup-open');

    try {
      window.localStorage.setItem(storageKey, 'true');
    } catch (error) {
      // Ignore storage failures and still close the popup.
    }
  });
});
